import React, { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent } from "@mui/material";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import OrgAddCard from "../Forms/OrgAddCard";

export default function AddModal({
  refresh,
  setRefresh,
  setAlertOpen,
  setAlertColour,
  setMessage,
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{ width: 100, paddingTop: 10 }}>
      <Button
        size="large"
        variant="contained"
        color="primary"
        onClick={handleClickOpen}
      >
        Add
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>
          Add Organization
          <IconButton
            sx={{ float: "right", width: "40px" }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <OrgAddCard
            setOpen={setOpen}
            refresh={refresh}
            setRefresh={setRefresh}
            setAlertOpen={setAlertOpen}
            setAlertColour={setAlertColour}
            setMessage={setMessage}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
